import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import styled from 'styled-components';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FixedBanner = styled.div.withConfig({
  displayName: "SearchWarningBanner__FixedBanner",
  componentId: "f02aph-0"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return {
    width: '100%',
    position: 'sticky',
    bottom: 0,
    left: 0,
    height: '33px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.color['fill-surface-default'],
    borderTop: `${theme.borderWidth['100']} solid ${theme.color['border-core-subtle']}`,
    zIndex: 5,
    gap: 5,
    padding: `${theme.space['250']} ${theme.space['0']}`
  };
});
const createExternalLinkComponent = href => _ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Link, Object.assign({}, props, {
    href: href,
    external: true,
    children: children
  }));
};
const BetaTerms = createExternalLinkComponent('https://legal.hubspot.com/hubspot-beta-terms');
const PrivacyPolicy = createExternalLinkComponent('https://legal.hubspot.com/privacy-policy');
const FAQs = createExternalLinkComponent('https://hubspot.com/products/artificial-intelligence');
const TooltipContent = () => /*#__PURE__*/_jsx(FormattedJSXMessage, {
  message: "reports.search.bannerWarningTooltip_jsx",
  elements: {
    BetaTerms,
    PrivacyPolicy,
    FAQs
  }
});
const SearchWarningBanner = () => /*#__PURE__*/_jsxs(FixedBanner, {
  children: [/*#__PURE__*/_jsxs(Text, {
    color: "text-core-subtle",
    as: "small",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "reports.search.bannerWarning"
    }), "."]
  }), /*#__PURE__*/_jsx(Text, {
    as: "small",
    children: /*#__PURE__*/_jsx(Link, {
      href: "https://legal.hubspot.com/hubspot-beta-terms",
      target: "_blank",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reports.search.bannerWarningLink"
      })
    })
  }), /*#__PURE__*/_jsx(Text, {
    as: "small",
    children: /*#__PURE__*/_jsx(HelpIcon, {
      title: /*#__PURE__*/_jsx(TooltipContent, {}),
      alignWithText: true
    })
  })]
});
export default SearchWarningBanner;